<template>
  <div class="home">
    <van-notice-bar
        left-icon="volume-o"
        text="有问题请联系客服咨询。"
    />

    <van-grid :gutter="10" clickable icon-size="60">
      <van-grid-item class="gametapicon" @click="gameicontap(index)" v-for="(value,index) in gameinfo" :key="value.id"
                     :icon="value.gamepic"
                     :text="value.name"/>
    </van-grid>
    <div class="submit">
      <van-divider
          :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
      >
        请选择服务器
      </van-divider>
      <van-form @submit="onSubmit">
        <van-field
            readonly
            clickable
            name="picker"
            :value="columns[0]"
            label="服务器选择"
            placeholder="点击选择服务器"
            @click="showPicker = true"
            right-icon="arrow-down"

        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="showPicker = false"
          />
        </van-popup>

        <van-divider
            :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
        >
          英雄选择
        </van-divider>
        <van-field class="heroimglist" name="checkboxGroup">
          <template #input>

            <van-checkbox-group class="imggroup" v-model="checkboxGroup" direction="horizontal">


              <van-checkbox v-for="(value,index) in current_hero_list" :name="value.name" class="herocheckbox">

                <template #icon="props">
                  <div class="imgfontbox">
                    <img class="heroimg" :src="value.heropic" alt=""/>
                    <span class="heroname">{{ value.name }}</span>

                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon"/>

                  </div>

                </template>

              </van-checkbox>


            </van-checkbox-group>

          </template>
        </van-field>

        <van-field name="radio" label="查询排序">
          <template #input>
            <van-radio-group v-model="radio" direction="horizontal">
              <van-radio name="1">SSR升序</van-radio>
              <van-radio name="2">SSR降序</van-radio>
            </van-radio-group>
          </template>
        </van-field>


        <div class="btn" style="margin: 16px;">
          <van-button @click="reset" class="btnleft" color="#7232dd" plain round size="normal" native-type="button">重置
          </van-button>
          <van-button class="btnright" round type="info" native-type="submit">查询</van-button>
        </div>

      </van-form>


    </div>
    <!--    <van-button type="primary">主要按钮</van-button>-->
  </div>
</template>

<script>
import {
  index
} from "@/api/home/"
import axios from "axios";

export default {
  data() {
    return {
      gameinfo: [], //游戏数据
      columns: [], //服务器选项
      value: [],

      showPicker: false, //展示弹出
      radio: '1',
      checkboxGroup: [], //复选框组
      checked: true,
      activeIcon: require('@/static/img/accc.png'),
      inactiveIcon: '',
      current_index: 0,
      current_hero_list: []
    }
  },
  created() {
    // axios({
    //   method: "get",
    //   url: 'http://127.0.0.1:8000/gamehandle/user/',
    //   params:{
    //     username:'baixu112233'
    //   },
    //   headers:{
    //         'authorization':`Token eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxLCJ1c2VybmFtZSI6Imh1YWx1byIsImV4cCI6MTY3NDAyNTI4MSwiZW1haWwiOiIiLCJvcmlnX2lhdCI6MTY3MzQyMDQ4MX0.x54MzFqaXMkLPgpSJMAE-8NkDaqyeYeMhQtBdJjF0Qk`,
    //       }
    // }).then(response => {
    //   console.log(response);
    // })
    index()
        .then(res => {

          this.gameinfo = res

          const server_list = res[0].get_game_server
          this.current_hero_list = res[this.current_index].get_game_hero


          for (var i = 0; i < server_list.length; i++) {
            this.columns[i] = server_list[i].name
            // console.log(server_list[i].name);

          }

        })
        .catch(err => {
              console.log(err)
            }
        )
  },
  // deactivated(){
  //   console.log('触发')
  // },
  methods: {
    onSubmit(values) {
      // console.log('submit', values);
      this.$router.push({name: 'query', params: {values: values}})
    },
    onConfirm(value) {
      // console.log(value)
      this.columns[0] = value
      this.value = value;
      this.showPicker = false;
    },

    gameicontap(index) {
      this.current_index = index
      // console.log(index)
      this.current_hero_list = this.gameinfo[this.current_index].get_game_hero
      const server_list = this.gameinfo[this.current_index].get_game_server
      // console.log(server_list)
      this.columns = []
      for (var i = 0; i < server_list.length; i++) {
        this.columns[i] = server_list[i].name
        // console.log(server_list[i].name);

      }
    },
    reset() {

      this.radio = '1'
      this.checkboxGroup = []
    },
  }
}

</script>

<style lang="scss" scoped>
//.gametapicon{
//  ::v-deep .van-grid-item__content{
//  background-color: #42b983;
//}
//}

.heroimglist {

  height: 100%;
  width: 100%;
  margin-top: -20px;

  .imggroup {
    justify-content: space-around;

    .herocheckbox {
      margin-top: -20px;
      height: 80px;
      width: 70px;
      padding-bottom: 20px;

      .imgfontbox {
        height: 70px;
        width: 70px;
        position: relative;

        .heroimg {

          position: absolute;
          width: 100%;
          height: 100%;
        }

        .heroname {
          font-size: 8px;
          color: aliceblue;
          position: absolute;
          width: 100%;
          bottom: 4px;
          z-index: 2;
          text-align: center;
          //font-family: "Helvetica Neue", Arial, sans-serif;
          line-height: 1.2;
          font-weight: bold;
          font-family: 'Noto Sans SC', sans-serif;
          background-color: rgba(0, 0, 0, 0.5);


        }

        .img-icon {
          height: 20px;
          margin: 25px 25px;

          position: relative;
          text-align: center;
        }
      }


    }
  }
}


.btn {
  display: flex;

  box-sizing: border-box;
  justify-content: space-around;
  flex-wrap: nowrap;
  padding-bottom: 50px;

  .btnleft {
    width: 45%;
  }

  .btnright {
    width: 45%;
  }

}


/*.heroimgbox {*/
/*  margin-top: -20px;*/
/*  height: 100px;*/
/*  width: 100px;*/
/*  padding-bottom: 50px;*/

/*}*/

/*.heroimg {*/
/*  height: 100px;*/
/*  width: 100px;*/


/*}*/

</style>